import { httpsCallable } from 'firebase/functions';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db, functions } from '../firebase';
import {
  CLOUD_COLLECTIONS,
  isControlledPaidDiscoveryCampaign
} from './cloudSchema';

function callable(name) {
  return httpsCallable(functions, name);
}

function normalizeCallableError(error, fallbackMessage) {
  const normalized = new Error(error?.message || fallbackMessage);
  normalized.code = error?.code || error?.details?.code || 'unknown';
  normalized.originalError = error;
  return normalized;
}

async function callTrustedDiscoveryFunction(name, payload, fallbackMessage) {
  try {
    const result = await callable(name)(payload);
    return result.data;
  } catch (error) {
    throw normalizeCallableError(error, fallbackMessage);
  }
}

export function shouldUseTrustedDiscovery(campaign) {
  return isControlledPaidDiscoveryCampaign(campaign);
}

export async function createTrustedCampaignImpression(campaignId) {
  return callTrustedDiscoveryFunction(
    'createCampaignImpression',
    { campaignId },
    'Discovery could not be started.'
  );
}

export async function startTrustedDiscoverySession(impressionId) {
  return callTrustedDiscoveryFunction(
    'startDiscoverySession',
    { impressionId },
    'Discovery session could not be started.'
  );
}

export async function skipTrustedCampaignImpression(impressionId) {
  return callTrustedDiscoveryFunction(
    'skipCampaignImpression',
    { impressionId },
    'Discovery could not be skipped.'
  );
}

export async function recordTrustedDiscoveryActivity(impressionId) {
  return callTrustedDiscoveryFunction(
    'recordDiscoveryActivity',
    { impressionId },
    'Discovery activity could not be recorded.'
  );
}

export async function submitTrustedDiscoveryFeedback({ impressionId, answer, message }) {
  return callTrustedDiscoveryFunction(
    'submitDiscoveryFeedback',
    { impressionId, answer, message },
    'Discovery feedback could not be submitted.'
  );
}

export async function settleTrustedDiscovery(impressionId) {
  return callTrustedDiscoveryFunction(
    'settleCampaignDiscovery',
    { impressionId },
    'Discovery reward could not be confirmed.'
  );
}

export async function getAuthoritativeUserProfile(userId = auth.currentUser?.uid) {
  if (!userId) return null;
  const snapshot = await getDoc(doc(db, CLOUD_COLLECTIONS.users, userId));
  if (!snapshot.exists()) return null;
  return snapshot.data();
}
